import * as React from 'react';
import { SVGProps } from 'react';

const IconConnectionSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.719 5.453 1.597 7.574a2 2 0 0 0 2.829 2.829l1.408-1.408c.42.112.855.154 1.286.128L5.133 11.11A3 3 0 1 1 .89 6.867l2.121-2.12a3 3 0 0 1 4.83.827l-.264.264a.996.996 0 0 1-.587.285 2 2 0 0 0-3.271-.67z" />
    <path d="M4.746 7.254a2.995 2.995 0 0 1-.586-.828l.263-.263a.996.996 0 0 1 .588-.286 2 2 0 0 0 3.271.67l2.121-2.121a2 2 0 0 0-2.828-2.829L6.166 3.006a4.018 4.018 0 0 0-1.286-.128L6.867.89a3 3 0 0 1 4.243 4.243L8.99 7.254a3 3 0 0 1-4.243 0z" />
  </svg>
);
export default IconConnectionSizeXs;
